import axios from "axios";
import { ethers } from "ethers";
import environmentVariables from "./environmentVariables";

export const multiple18 = (value) => {
  return parseInt(value) * 1000000000000000000
}
export const multiple18String = (value) => {
  const value12 = parseInt(value) * 1000000000000000000
  return value12.toString()
}
export const multiple18Str = (value) => {
  const value12 = value * 1000000000000000000
  return value12.toString()
}

export const divide18 = (value) => {
  return parseInt(value) / 1000000000000000000
}

export const divide18String = (value) => {
  const value12 = parseInt(value) / 1000000000000000000
  return value12.toString()
}

export function ms(t) {
  let year,
      month,
      day,
      hour,
      minute,
      second;

  second = Math.floor(t / 1000);
  minute = Math.floor(second / 60);
  second = second % 60;
  hour = Math.floor(minute / 60);
  minute = minute % 60;
  day = Math.floor(hour / 24);
  hour = hour % 24;
  month = Math.floor(day / 30);
  day = day % 30;
  year = Math.floor(month / 12);
  month = month % 12;

  // return { year, month, day, hour, minute, second };
  return month;
}
const checkIsUSDT = (address) => {
  if (address === "0xc2132D05D31c914a87C6611C10748AEb04B58e8F" || address === "USDT") {
    return true;
  } else {
    return false;
  }
};

export const convertedMulPrice = (currency, price) => {
  // console.log('price', price)
  // parseUnits for multiply 
  // formatUnits for divide 
  return checkIsUSDT(currency)
    ? ethers.parseUnits(price, 6)
    : ethers.parseUnits(price, 18)
};

export const convertedDivPrice = (currency, price) => {
  // parseUnits for multiply 
  // formatUnits for divide 
  return checkIsUSDT(currency)
    ? ethers.formatUnits(price, 6)
    : ethers.formatUnits(price, 18)
};

export const getRPCURL=()=>{
  try{
    axios.get(`${environmentVariables?.apiUrl}/nftmarketplace/api/v1/get/rpc`).then(response=>{
      if(response?.data?.success==true){
        return response?.data?.data
      }else{
        return null;
      }
    }).catch(err=>{
      console.log(err);
      return null;
    })
  }catch(err){
    console.log(err)
  }
}

export const truncateNumberBalance=(num,places)=>{
  if(num==null||num==undefined||num==""||num==0){
    return 0;
  }
  if(places==null||places==undefined||places==""||places==0){
    places=1;
  }
  if(places>5){
    places=1;
  }
  if(typeof num=="string"){
    num=Number(num)
  }
  let multiplier=10**places;
  return Math.floor(num*multiplier)/multiplier;
}

export function formatNumber(num) {
  if (typeof num !== "number") return num; // safeguard
  const decimalPlaces = num.toString().split(".")[1]?.length || 0;
  
  if (decimalPlaces > 6) {
    return num.toFixed(6); // keep 6 decimal places
  } else {
    return num; // show as-is
  }
}